import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-atividade-coletiva`

    return {

        paciente(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
        },
        index(){
            return repository.get(`${baseUrl}`);
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        getPses(params){
            return repository.get(`${baseUrl}/getPses?${urlUtil.serialize(params)}`)
        },
        getTurnos(params){
            return repository.get(`${baseUrl}/getTurnos?${urlUtil.serialize(params)}`)
        },
        getUnidades(params){
            return repository.get(`${baseUrl}/getUnidades?${urlUtil.serialize(params)}`)
        },
        getLocaisAtendimentos(params){
            return repository.get(`${baseUrl}/getLocaisAtendimentos?${urlUtil.serialize(params)}`)
        },
        getProfissionais(params){
            return repository.get(`${baseUrl}/getProfissionais?${urlUtil.serialize(params)}`)
        },
        getOcupacoes(params){
            return repository.get(`${baseUrl}/getOcupacoes?${urlUtil.serialize(params)}`)     
        },
        getEquipes(params){
            return repository.get(`${baseUrl}/getEquipes?${urlUtil.serialize(params)}`)     
        },
        getAtividades(params){
            return repository.get(`${baseUrl}/getAtividades?${urlUtil.serialize(params)}`)     
        },
        getPublicosAlvo(params){
            return repository.get(`${baseUrl}/getPublicosAlvo?${urlUtil.serialize(params)}`)     
        },
        getTemasSaude(params){
            return repository.get(`${baseUrl}/getTemasSaude?${urlUtil.serialize(params)}`)     
        },
        getPraticasSaude(params){
            return repository.get(`${baseUrl}/getPraticasSaude?${urlUtil.serialize(params)}`)     
        },
        getProcedimentos(params){
            return repository.get(`${baseUrl}/getProcedimentos?${urlUtil.serialize(params)}`)     
        }
        
    }

}